import LetterAvatar from "@/components/Avatar/LetterAvatar"
import StatusBadge from "@/components/ui/badge"

export const columns = [
  {
    header: "Date",
    accessorKey: "started_at",
  },

  {
    header: "Status",
    cell: ({ row }) => <StatusBadge name={row.original.status} />,
  },
]
